export default {
  server_url: "http://localhost:0000"
};
